<template>
  <div class="deleted-bar flex justify-center items-center min-h-6 bg-destructive-bg">
    <div class="text-text-default text-sm">
      {{ message }}
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import useTranslate from '@/utilities/composables/useTranslate';

export default {
  name: 'DeletedProjectBanner',
  props: {
    resourceType: {
      type: String,
      default: 'project',
    },
    deletedProjectName: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { translate } = useTranslate();
    const { resourceType, deletedProjectName: dpn } = props;

    const message = computed(() => {
      const project = 'project';
      const isSpace = resourceType === project;
      const rt = translate(resourceType);
      const thisResource = `${translate('this')} ${rt}`;
      return isSpace
        ? `${thisResource} ${translate('hasBeenDeleted')}.`
        : `${thisResource} ${translate('andTheEntire')} ${dpn} ${translate(project)} ${translate(
            'hasBeenDeleted'
          )}.`;
    });

    return {
      message,
    };
  },
};
</script>
